/**
 * Load WASM file using fetch (browser environment)
 * @param path - URL or path to the wasm file
 * @returns ArrayBuffer containing the wasm binary
 */
export const WasmLoad = async (path: string): Promise<ArrayBuffer> =>
  fetch(new URL(path, import.meta.url)).then(response => response.arrayBuffer())
